export default {
  Type: 'Тип',
  Discount: 'Знижка',
  Name: 'Назва',
};
